import * as React from "react";
import { LOGO_PATHS, LOGO_VIEWBOX, MARK_PATHS, MARK_VIEWBOX } from "./logoPaths";

export default function LogoDark({
    markOnly = false,
    color = "white",
}: {
    markOnly?: boolean;
    color?: string;
}) {
    return (
        <svg
            width={markOnly ? 27 : 127}
            height="24"
            viewBox={markOnly ? MARK_VIEWBOX : LOGO_VIEWBOX}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {(markOnly ? MARK_PATHS : LOGO_PATHS).map((d, i) => (
                <path key={i} d={d} fill={color} />
            ))}
        </svg>
    );
}
